<div class="dialog-container">
  <h2 mat-dialog-title class="title">{{ this.downloading ? 'Downloading...' : 'Export to CSV or Excel?' }}</h2>
  @if (!exportIsCSV()) {
  <h3 mat-dialog-title class="title">Excel exports can take a while. Please be patient.</h3>
  }
  <mat-icon class="close-button" (click)="close()">clear</mat-icon>
  <div class="spinner">
    @if (downloading) {
    <mat-spinner></mat-spinner>
    }
  </div>
  @if (!downloading) {
  <mat-button-toggle-group class="toggle" [(value)]="exportType">
    <mat-button-toggle value="csv" class="toggle-value">CSV</mat-button-toggle>
    <mat-button-toggle value="excel" class="toggle-value">Excel</mat-button-toggle>
  </mat-button-toggle-group>
  } @if (!downloading) {
  <mat-dialog-actions>
    <button mat-raised-button (click)="export()">Export</button>
  </mat-dialog-actions>
  }
</div>
